import styled from 'styled-components'

export const Wrapper = styled.a`
  display: flex;
  background-color: var(--brand-primary);
  border-radius: 12px;
  box-sizing: border-box;
  height: 100%;
  padding: 40px;
  text-decoration: none;
  flex-direction: column;
  justify-content: space-between;

  h4 {
    height: max-content;
  }

  @media (max-width: 768px) {
    padding: 18px;
  }
`

export const IconWrapper = styled.div`
  @media (max-width: 768px) {
    svg {
      width: 30px;
      height: 30px;
    }
  }
`
